import React from "react";

const AppContext = React.createContext({
    goBack: true
});

export default(AppContext);